import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogConfig, MenuItem, DialogService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { AlertUtil } from '../utils/alert-util';
import { DocumentiService } from '../services/documenti.service';
import { ICommessa } from '../interfaces/ICommessa';
import { IPagamentoAttivita } from '../interfaces/IPagamentoAttivita';
import { ISal } from '../interfaces/ISal';
import * as Moment from 'moment'
import { RequestBuilder } from '../classes/request-builder';
import { Loading } from '../utils/loading';
import * as Enum from '../utils/enums';
import { OverlayPanel } from 'primeng/overlaypanel';
import { finalize } from 'rxjs/operators';
import { Util } from '../utils/util';
import { IPagamento } from '../interfaces/IPagamento';
import { SalForCommessaModalComponent } from '../sal-for-commessa-modal/sal-for-commessa-modal.component';
import { CommessaService } from '../services/commessa.service';
import { PaymentForCommessaModalComponent } from '../payment-for-commessa-modal/payment-for-commessa-modal.component';

@Component({
  selector: 'app-commessa-sal-payment-modal',
  templateUrl: './commessa-sal-payment-modal.component.html',
  styleUrls: ['./commessa-sal-payment-modal.component.css']
})
export class CommessaSalPaymentModalComponent implements OnInit {
  @ViewChild('op') op: OverlayPanel
  commessa: ICommessa                         //from table commesse
  data: any                                   //for chart
  options: any                                //for chart
  listPagamenti: IPagamentoAttivita[]         //lista pagamenti commessa
  listSAL: ISal[]                             //lista SAL commessa
  arrayDate: string[] = []                    //array of date
  arrayAvanzamento: number[] = []             //array avanzamento
  itemsAllegato: MenuItem[];                  //menu item
  attachmentUrl: string = ""                  //url dell'allegato

  constructor(private config: DynamicDialogConfig,
    private translate: TranslateService,
    private alertUtil: AlertUtil,
    private dialogService: DialogService,
    private commessaService: CommessaService,
    private documentiService: DocumentiService) {

    this.commessa = this.config.data.commessa
  }

  ngOnInit() {
    this.checkObjAndSetField()
    this.getChartDat()
  }

  /**
   * check obj
   * set component for chart and html
   */
  checkObjAndSetField() {
    //SET lista pagamenti for html
    if (this.commessa.Pagamenti) {
      this.listPagamenti = this.commessa.Pagamenti
    }

    //SET list SAL for chart
    this.listSAL = this.commessa.SAL;
    let count = 0
    this.arrayDate = []
    this.arrayAvanzamento = []
    this.listSAL.forEach(item => {
      let dateFormatted: string;
      dateFormatted = this.formatDateForChart(item.Data);
      this.arrayDate.push(dateFormatted);
      this.arrayAvanzamento.push(item.Avanzamento_percentuale + count);
      count += item.Avanzamento_percentuale
    });
  }

  /**
   * get chart data
   */
  getChartDat() {
    this.data = {
      labels: this.arrayDate,
      datasets: [
        {
          label: this.commessa.Nome,
          data: this.arrayAvanzamento,
          fill: false,
          borderColor: '#4bc0c0'
        }
      ]
    }
    //add € to avanzamento and tooltip
    this.options = {
      scales: {
        yAxes: [{
          stacked: true,
          ticks: {
            callback: function (value, index, values) {
              return value + "€";
            }
          }
        }]
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItems, data) {
            return data.datasets[tooltipItems.datasetIndex].label + ': ' + tooltipItems.yLabel + ' €'
          }
        }
      }
    }
  }

  /**
   * format date for html
   * @param date string from service
   */
  formatDateForChart(date: any): string {
    // format date value
    let valueMoment = Moment(date, "YYYY-MM-DDTHH:mm:ssZ", true)
    if (valueMoment.isValid()) {
      date = valueMoment.format("DD/MM/YYYY")
    }
    return date
  }

  /**
   * open menu for download file
   * @param menu 
   * @param sal sal selected
   * @param pagamento pagamento selected
   */
  openMenu(menu, sal: ISal, pagamento: IPagamento) {
    this.optionsAllegato(pagamento, sal)
    menu.toggle(event)
  }

  /**
   * set options open allegato
   * @param fromAttivita boolean
   * @param payment obj selected
   * @param sal obj selected
   */
  private optionsAllegato(payment: IPagamento, sal: ISal) {
    this.translate.get(["LBL_ALLEGATO_APRI", "LBL_ALLEGATO_CANCELLA",]).subscribe(res => {
      this.itemsAllegato = [
        {
          label: res["LBL_ALLEGATO_APRI"], icon: 'pi pi-download', command: () => {
            this.openAllegato(payment, sal);
          }
        }
      ];
    })
  }

  /**
   * 
   * @param payment obj selected
   * @param sal obj selected
   */
  openAllegato(payment: any, sal: any) {
    if (payment) {
      this.scaricaAllegatoPagamentoCommessa(payment)
    } else {
      this.scaricaAllegatoSALCommessa(sal)
    }
  }

  /**
   * scarica allegato SAL commessa
   */
  scaricaAllegatoSALCommessa(sal: any) {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({
      IdSAL: sal.Id
    })

    this.documentiService.visualizzaSALCommessa(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response && response["error"] == null) { //RESPONSE OK
          this.downloadAllegato(null, sal, response);
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code;
          this.alertUtil.showErrorAlert(errorKey);
          console.log("ERROR: " + JSON.stringify(response.error.Stack));
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message });
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )
  }




  /**
   * scarica allegato pagamento commessa
   */
  scaricaAllegatoPagamentoCommessa(payment: any) {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({
      IdPagamento: payment.Id
    })

    this.documentiService.visualizzaPagamentoCommessa(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response && response["error"] == null) { //RESPONSE OK
          this.downloadAllegato(payment, null, response);
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code;
          this.alertUtil.showErrorAlert(errorKey);
          console.log("ERROR: " + JSON.stringify(response.error.Stack));
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message });
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )
  }

  /**
   * download allegato
   */
  private downloadAllegato(payment: any, sal: any, response: any) {
    let allegatoType = payment ? payment.Estensione_allegato.trim() : sal.Estensione_allegato.trim()
    let allegatoNome = payment ? payment.NomeAllegato : sal.NomeAllegato
    if (!allegatoType) {
      allegatoType = allegatoNome.substring(allegatoNome.lastIndexOf("."));
    }
    if (allegatoType == Enum.FILE_TYPE_ENUM.PDF) {
      Util.showPdf(response);
    }
    else if (allegatoType == Enum.FILE_TYPE_ENUM.JPEG || allegatoType == Enum.FILE_TYPE_ENUM.JPG
      || allegatoType == Enum.FILE_TYPE_ENUM.PNG) {
      this.attachmentUrl = "data:image/" + allegatoType + ";base64," + response;
      //Apertura dell'overlay panel
      this.op.toggle(event);
    }
    else {
      Util.downloadFile(response, allegatoType, allegatoNome);
    }
  }

  /**
   * callback fired when SAL update button is clicked
   * @param sal 
   */
  onUpdateSALClick(sal: ISal) {
    //cannot update first SAL
    if (sal.Id != this.commessa.SAL[0].Id) {
      //get header translation
      this.translate.get("LBL_UPDATE_SAL").subscribe(res => {
        //open sal modal
        let ref = this.dialogService.open(SalForCommessaModalComponent, {
          data: {
            listCommesse: [this.commessa],
            sal: sal
          },
          header: res,
          width: '50%'
        })

        // refresh sal list when modal is closed and SAL is updated
        ref.onClose.subscribe((SALSaved: ISal) => {
          if (SALSaved) {
            //refresh overriding old sal
            // find sal index into array
            let salIndex = this.commessa.SAL.findIndex(sal => sal.Id == SALSaved.Id)
            // override sal
            if (salIndex > -1) {
              this.commessa.SAL.splice(salIndex, 1, SALSaved)
            }
            this.checkObjAndSetField()
            this.getChartDat()
          }
        })
      })
    } else {
      this.alertUtil.showAlert('LBL_CANNOT_UPDATE_SAL')
    }

  }

  /**
   * callback fired when SAL delete button is clicked
   * @param sal 
   */
  onDeleteSALClick(sal: ISal) {
    //cannot delete first SAL
    if (sal.Id != this.commessa.SAL[0].Id) {
      this.alertUtil.showConfirmationAlert("LBL_DELETE_SAL_CONFIRM", null, null, null, null, () => {
        this.deleteSAL(sal)
      })
    } else {
      this.alertUtil.showAlert('LBL_CANNOT_DELETE_SAL')
    }
  }

  /**
   * call WS to delete SAL
   * @param salToDelete 
   */
  deleteSAL(salToDelete: ISal) {
    let reqBuilder = new RequestBuilder({ Id: salToDelete.Id })
    this.commessaService.deleteSALofCommessa(reqBuilder).subscribe(
      response => {
        Loading.isLoading = false
        if (response.data) {
          //remove SAL deleted if response OK
          this.alertUtil.showAlert('LBL_DELETE_SAL', null, null, null, () => {
            this.commessa.SAL.forEach((sal, index) => {
              if (sal.Id == salToDelete.Id) {
                this.commessa.SAL.splice(index, 1)
              }
            })
            this.checkObjAndSetField()
            this.getChartDat()
          })
        } else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        } else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        Loading.isLoading = false
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * callback fired when Payment update button is clicked
   * @param sal 
   */
  onUpdatePaymentClick(payment: IPagamento) {
    //get header translation
    this.translate.get("LBL_UPDATE_PAYMENT").subscribe(res => {
      //open payment modal
      let ref = this.dialogService.open(PaymentForCommessaModalComponent, {
        data: {
          listCommesse: [this.commessa],
          payment: payment
        },
        header: res,
        width: '50%'
      })

      // refresh payments list when modal is closed and payment is updated
      ref.onClose.subscribe((paymentSaved: IPagamento) => {
        if (paymentSaved) {
          //refresh overriding old payment
          // find payment index into array
          let paymentIndex = this.commessa.Pagamenti.findIndex(payment => payment.Id == paymentSaved.Id)
          // override payment
          if (paymentIndex > -1) {
            this.commessa.Pagamenti.splice(paymentIndex, 1, paymentSaved)
          }
          this.checkObjAndSetField()
        }
      })
    })
  }

  /**
   * callback fired when Payment delete button is clicked
   * @param sal 
   */
  onDeletePaymentClick(payment: IPagamento) {
    this.alertUtil.showConfirmationAlert("LBL_DELETE_PAYMENT_CONFIRM", null, null, null, null, () => {
      this.deletePayment(payment)
    })
  }

  /**
   * call WS to delete Payment
   * @param paymentToDelete 
   */
  deletePayment(paymentToDelete: IPagamento) {
    let reqBuilder = new RequestBuilder({ Id: paymentToDelete.Id })
    this.commessaService.deletePagamentoforCommessa(reqBuilder).subscribe(
      response => {
        Loading.isLoading = false
        if (response.data) {
          //remove Payment deleted if response OK
          this.alertUtil.showAlert('LBL_DELETE_PAYMENT', null, null, null, () => {
            this.commessa.Pagamenti.forEach((payment, index) => {
              if (payment.Id == paymentToDelete.Id) {
                this.commessa.Pagamenti.splice(index, 1)
              }
            })
            this.checkObjAndSetField()
          })
        } else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        } else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        Loading.isLoading = false
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }
}
